module.exports = __webpack_public_path__ + "img/people_img_5_1.0b9b1161.png";